import { useEffect } from "react";
import { init } from "emoji-mart";

export default function EmojiPickerInitializer(): JSX.Element | null {
  async function fetchEmojiData() {
    const response = await fetch("https://cdn.jsdelivr.net/npm/@emoji-mart/data");

    init(response.json() as unknown as EmojiData);
  }

  useEffect(() => {
    fetchEmojiData();
  }, []);

  return null;
}

interface EmojiData {
  categories: Array<{ id: string; emojis: string[] }>;
  emojis: Record<
    string,
    {
      id: string;
      name: string;
      keywords: string[];
      skins: { unified: string; native: string };
      version: number;
    }
  >;
  aliases: Record<string, string>;
  sheet: { cols: number; rows: number };
}
